import React from 'react';
import red_line from '../../../img/red_line.png';
import './SectionTitle.css';

export const SectionTitle = ({ text }) => (
  <div className="section-title">
    <img src={red_line} alt="red line" />
    <p className="section-title-text">{text}</p> 
  </div> 
);
